import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { smartBack } from './returnTo';

/**
 * Header-friendly smart back handler.
 *
 * @param {{ fallback?: string }} options
 * @returns {{ onBack: () => void }}
 *
 * Usage: <Header backArrow onBack={useSmartBack({ fallback: '/builder/sales' }).onBack} />
 */
export function useSmartBack({ fallback = '/' } = {}) {
  const navigate = useNavigate();
  const location = useLocation();

  const onBack = useCallback(() => {
    smartBack(navigate, location, { fallback });
  }, [navigate, location, fallback]);

  return { onBack };
}

export default useSmartBack;
